// Stern-Farbpalette — Single Source of Truth (matches backend ALLOWED_STAR_COLORS)
export const STAR_COLOR_MAP = {
    white: { hex: "#fefce8", label: "Warmes Weiß" },
    gold: { hex: "#f0c674", label: "Gold" },
    amber: { hex: "#fcd34d", label: "Amber" },
    rose: { hex: "#fbcfe8", label: "Rosé" },
    lavender: { hex: "#ddd6fe", label: "Lavendel" },
    sky: { hex: "#bfdbfe", label: "Himmel-Blau" },
    mint: { hex: "#a7f3d0", label: "Mint" },
};

export const STAR_COLOR_OPTIONS = Object.entries(STAR_COLOR_MAP).map(([key, v]) => ({
    key,
    ...v,
}));

export function hexFor(starColorKey) {
    if (!starColorKey) return null;
    return STAR_COLOR_MAP[starColorKey]?.hex || null;
}
